import React from 'react';
import ActivityOptions from 'components/flink-components/ActivityOptions/ActivityOptions';
import CheckboxGroup from 'components/flink-components/ActivityOptions/CheckboxGroup';
import './MathRodsOptions.scss';

// The common Make Options tab mounts this isolated per-template panel.
// The two visible checkboxes behave as an exclusive choice: each segment's
// captured workspace image opens in exactly one native writing editor.
export default function MathRodsOptions({ options = {}, changeHandler, translate, defaultOptions = {} }) {
  const selected = options.writingActivity === 'writing-assistant' ? 'writing-assistant' : 'story-studio';
  return <div className="math-rods-own-options">
    <ActivityOptions options={options} changeHandler={changeHandler}
      optionsToRender={['delayBeforeNext', 'showAnswer']} defaultOptions={defaultOptions} />
    <div className="math-rods-writing-option" role="group" aria-label={translate(0, 'Writing Activity')}>
      <strong>{translate(0, 'Writing Activity')}:</strong>
      <label><input type="checkbox" checked={selected === 'story-studio'}
        onChange={() => changeHandler('writingActivity', 'story-studio')} />
        {translate(0, 'Story Studio')}</label>
      <label><input type="checkbox" checked={selected === 'writing-assistant'}
        onChange={() => changeHandler('writingActivity', 'writing-assistant')} />
        {translate(0, 'Writing Assistant')}</label>
    </div>
    <CheckboxGroup label={translate(0, 'Show Grid in Play')}
      name="showGrid" current={options} defaultChecked={false} changeHandler={changeHandler} />
  </div>;
}
